import { Table, Alert, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setIsLoading } from '../general/actions';
import React, { useEffect, useState } from 'react';
import axiosInstance from '../general/axiosInstance';
import { Link } from 'react-router-dom';
import { currencyFormater, LOGO_IMG_PATH } from '../general/utils';

function AgreementList(props) {
    const { setIsLoading, showProductsBtn, organization_id } = props;
    const [message, setMessage] = useState('');
    const [agreements, setAgreements] = useState([]);

    const getAgreements = () => {
        if (!organization_id) return;
        setIsLoading(true);
        axiosInstance.get('/agreements/current-organization')
            .then(res => {
                setIsLoading(false);
                if (res?.data?.length) {
                    setAgreements(res.data);
                    setMessage('');
                } else {
                    setMessage('No hay contratos en el sistema');
                }
            })
            .catch(() => setIsLoading(false));
    };

    useEffect(() => { getAgreements(); }, []);

    return (
        <>
            {!showProductsBtn && (
                <div className="order-section-header" style={{ borderRadius: '14px 14px 0 0', marginTop: 16 }}>
                    <i className="fa fa-file-text-o" /> Contratos de la entidad
                </div>
            )}

            {message && <Alert variant="info" className="mt-2">{message}</Alert>}

            {agreements.length > 0 && (
                <Table responsive className="report-table mb-0">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Contrato</th>
                            <th>Descripción</th>
                            <th>Cliente</th>
                            <th>Proveedor</th>
                            <th>Inicio</th>
                            <th>Fin</th>
                            <th>Monto</th>
                            <th>Hrs. mín.</th>
                            <th>Activo</th>
                            {showProductsBtn && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {agreements.map(a => (
                            <tr key={a.id}>
                                <td style={{ fontWeight: 700, color: 'var(--abi-primary)' }}>#{a.id}</td>
                                <td><span className="product-card-extid">{a.ext_id}</span></td>
                                <td style={{ fontSize: 13 }}>{a.description}</td>
                                <td style={{ fontSize: 12 }}>{a.customer.ext_id} — {a.customer.name}</td>
                                <td>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                        <img height="20" width="20" style={{ objectFit: 'contain', borderRadius: 4, border: '1px solid var(--abi-border)' }}
                                            src={LOGO_IMG_PATH + a.provider.id + '.png'} alt=""
                                            onError={(e) => { e.target.style.display = 'none'; }} />
                                        <span style={{ fontSize: 12 }}>{a.provider.ext_id} — {a.provider.name}</span>
                                    </div>
                                </td>
                                <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{a.start_date}</td>
                                <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{a.end_date}</td>
                                <td style={{ fontWeight: 600 }}>{currencyFormater(a.amount)}</td>
                                <td className="text-center">{a.min_hours_deliver}h</td>
                                <td>
                                    <span className="report-status-badge" style={
                                        a.is_active
                                            ? { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }
                                            : { background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }
                                    }>
                                        {a.is_active ? 'Activo' : 'Inactivo'}
                                    </span>
                                </td>
                                {showProductsBtn && (
                                    <td>
                                        <Button as={Link} to={'/products/' + a.id} size="sm" variant="outline-primary">
                                            <i className="fa fa-shopping-cart" /> Productos
                                        </Button>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading, organization_id: state.organization_id };
}

const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(AgreementList);
